import { useDispatch } from 'react-redux';
import { usePageView } from 'hooks/pageView';
import {
  COOKIE_CONSENT_MODAL,
  SELECT_ACCEPT_COOKIE,
  SELECT_CLOSE_MODAL,
  SELECT_CONTINUE_WITHOUT_CONSENTING_COOKIE,
} from 'constants/metrics';
import { closeModal } from 'store/slices/modal';
import { updateUserCookiePreference } from 'store/slices/user';
import { MusicButton } from 'components/MusicButton';
import { FormattedMessage } from 'react-intl';
import CookiePreferences from 'components/Links/CookiePreferences';
import CookieNotice from 'components/Links/CookieNotice';
import PrivacyNotice from 'components/Links/PrivacyNotice';
import './styles.scss';

export const CookieConsentModal = () => {
  const dispatch = useDispatch();
  usePageView(COOKIE_CONSENT_MODAL);

  const onClose = () => {
    dispatch(closeModal());
  };

  const acceptCookie = () => {
    dispatch(updateUserCookiePreference({ preference: 'ACCEPT' }));
    dispatch(closeModal());
  };

  const rejectCookie = () => {
    dispatch(updateUserCookiePreference({ preference: 'REJECT' }));
    dispatch(closeModal());
  };

  return (
    <div className="CookieConsent">
      <div className="CookieConsent__body">
        <MusicButton
          class="CookieConsent__close-button"
          icon-only
          icon-name="cancel"
          variant="glass"
          size="small"
          onMusicActivate={onClose}
          data-id={`${SELECT_CLOSE_MODAL}-${COOKIE_CONSENT_MODAL}`}
        />
        <h4 className="CookieConsent__title">
          <FormattedMessage
            id="cookie-banner-headline"
            defaultMessage="Select your cookie preferences"
          />
        </h4>
        <p>
          <FormattedMessage
            id="cookie-banner-text-1"
            values={{
              cookieNotice: <CookieNotice />,
            }}
            defaultMessage="We use cookies and similar tools that are necessary to enable you to make purchases, to enhance your experiences and to provide our services, as detailed in our {cookieNotice}. We also use these cookies to understand how customers use our services (for example, by measuring visits to our service) so we can make improvements."
          />
        </p>
        <p>
          <FormattedMessage
            id="cookie-banner-text-2"
            values={{
              cookieNotice: <CookieNotice />,
              privacyNotice: <PrivacyNotice />,
            }}
            defaultMessage="If you agree, we’ll also use cookies to complement your shopping and browsing experience across Amazon Music services as described in our {cookieNotice}. This includes using first- and third-party cookies which store or access standard device information such as a unique identifier. Third parties use cookies for their purposes of displaying and measuring personalized ads, generating audience insights, and developing and improving products. You can decline these cookies, make more detailed choices, or learn more by going to (cookiePreferences). To learn more about how and for what purposes Amazon uses personal information (such as Amazon Music listening history, Amazon Music for Artists usage history and Podcaster Portal usage history), please go to our {privacyNotice}."
          />
        </p>
        <MusicButton
          variant="solid"
          onMusicActivate={acceptCookie}
          className="CookieConsent__button MusicButton__wide"
          data-id={`${SELECT_ACCEPT_COOKIE}-${COOKIE_CONSENT_MODAL}`}
        >
          <FormattedMessage id="accept-cookies" />
        </MusicButton>
        <MusicButton
          variant="outline"
          onMusicActivate={rejectCookie}
          className="CookieConsent__button MusicButton__wide"
          data-id={`${SELECT_CONTINUE_WITHOUT_CONSENTING_COOKIE}-${COOKIE_CONSENT_MODAL}`}
        >
          <FormattedMessage id="continue-without-consenting" />
        </MusicButton>
        <p className="CookieConsent__customize-cookie">
          <FormattedMessage
            id="customize-cookie"
            values={{
              cookiePreferences: <CookiePreferences />,
            }}
            defaultMessage="To Customize Cookies go to {cookiePreferences}"
          />
        </p>
      </div>
    </div>
  );
};
